// Keuze dit product / gekoppeld product (blocks/rf-gift-delivery.liquid), bijv. cadeaubon digitaal / gedrukt
// of Signature volledig / 30% aanbetaling. Bij optie 2 komt bij het toevoegen de variant op dezelfde plek
// van het gekoppelde product in de winkelwagen. Horizon leest bij het
// versturen het verborgen veld name="id"; we wisselen dat in de capture-fase op window
// (Horizon luistert zelf op document, dus window is eerder) en zetten het direct daarna terug.
document.querySelectorAll('[data-rf-gift-delivery]').forEach((root) => {
  if (!(root instanceof HTMLElement) || root.dataset.rfReady) return;
  root.dataset.rfReady = 'true';

  const formId = root.dataset.formId || '';
  const mapScript = root.querySelector('script[type="application/json"]');
  /** @type {Record<string, string>} */
  const map = mapScript ? JSON.parse(mapScript.textContent || '{}') : {};
  const isPrinted = () => root.querySelector('input:checked')?.getAttribute('value') === 'printed';
  const getForm = () => document.getElementById(formId);

  const update = () => {
    const printed = isPrinted();
    root.querySelectorAll('[data-rf-note]').forEach((note) => {
      if (note instanceof HTMLElement) note.hidden = note.dataset.rfNote !== (printed ? 'printed' : 'digital');
    });
    // Gedrukte kaart: geen ontvanger-e-mail nodig. Terug naar "naar mij" (zet de velden uit) en verbergen.
    const recipient = getForm()?.querySelector('gift-card-recipient-form');
    if (recipient instanceof HTMLElement) {
      if (printed) {
        const self = recipient.querySelector('input[value="self"]');
        if (self instanceof HTMLInputElement && !self.checked) self.click();
      }
      recipient.hidden = printed;
    }
  };

  root.addEventListener('change', update);
  update();

  // Bedragen in labels/uitleg ([alt_price] e.d.) meenemen bij een andere variant.
  const section = root.closest('[id*="ProductInformation-"]') || document;
  section.addEventListener('variant:update', (event) => {
    const html = event.detail?.data?.html;
    const fresh = html?.querySelector(`#${CSS.escape(root.id)}`);
    if (!fresh) return;
    root.querySelectorAll('[data-rf-text]').forEach((el) => {
      const next = fresh.querySelector(`[data-rf-text="${el.getAttribute('data-rf-text')}"]`);
      if (next) el.innerHTML = next.innerHTML;
    });
  });

  window.addEventListener(
    'submit',
    (event) => {
      const form = event.target;
      // form.id is hier het veld name="id", dus het attribuut uitlezen.
      if (!(form instanceof HTMLFormElement) || form.getAttribute('id') !== formId || !isPrinted()) return;
      const input = form.querySelector('input[name="id"]');
      if (!(input instanceof HTMLInputElement)) return;
      const printedId = map[input.value];
      if (!printedId) return;
      const original = input.value;
      input.value = printedId;
      setTimeout(() => {
        input.value = original;
      }, 0);
    },
    true
  );
});
